export default __webpack_public_path__ + "static/media/google_play.14a24df8.svg";